// Action-menu button labels for activated abilities. The full effect
// clause lives on `entry.description` (and the card text), but a button
// must stay terse. Long descriptions overflow the menu and read as a
// wall of rules text. `activatedMenuLabel` resolves the shortest
// faithful label, capped at four words.
//
// Resolution order:
//   1. `entry.menuLabel`. A card may hand-author its button text.
//   2. `entry._builtin`. Built-ins already carry a tight description
//      ("Put on a mask", "Draw a site", "Draw a spell").
//   3. `OP_LABELS[op]`. A curated short label for known effect ops
//      whose description truncates badly (Pathfinder's site-play tap).
//   4. First four words of the description.
//   5. "Activate." Nothing else to go on.

const OP_LABELS = {
  pathfinder_tap: 'Play a site',
};

const MAX_WORDS = 4;

function firstWords(text) {
  if (typeof text !== 'string') return '';
  const words = text.trim().replace(/[.\s]+$/, '').split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length <= MAX_WORDS) return words.join(' ');
  return `${words.slice(0, MAX_WORDS).join(' ')}…`;
}

export function activatedMenuLabel(entry) {
  if (!entry) return 'Activate';
  if (entry.menuLabel) return entry.menuLabel;
  if (entry._builtin && entry.description) return entry.description;
  const op = entry.effect?.[0]?.op;
  if (op && OP_LABELS[op]) return OP_LABELS[op];
  return firstWords(entry.description) || 'Activate';
}
